"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.floor = void 0;
const floor = (value, precision) => {
    if (!precision) {
        return Math.floor(value);
    }
    precision = !precision
        ? 0
        : precision >= 0
            ? Math.min(precision, 292)
            : Math.max(precision, -292);
    // Shift with exponential notation to avoid floating-point issues.
    // See [MDN](https://mdn.io/round#Examples) for more details.
    let pair = `${value}e`.split('e');
    const preparedVal = Math.floor(Number(`${pair[0]}e${+pair[1] + precision}`));
    pair = `${preparedVal}e`.split('e');
    return +`${pair[0]}e${+pair[1] - precision}`;
};
exports.floor = floor;
//# sourceMappingURL=floor.js.map